const THEME_STORAGE_KEY = "darkMode";
const THEME_EVENT = "themechange";

export function getStoredDarkMode() {
  const stored = sessionStorage.getItem(THEME_STORAGE_KEY);
  return stored === null ? true : stored === "true";
}

export function applyTheme(darkMode) {
  document.documentElement.classList.toggle("light", !darkMode);
}

export function setStoredDarkMode(darkMode) {
  sessionStorage.setItem(THEME_STORAGE_KEY, String(darkMode));
  applyTheme(darkMode);
  window.dispatchEvent(
    new CustomEvent(THEME_EVENT, { detail: { darkMode } })
  );
}

export function subscribeToThemeChange(callback) {
  const handler = (event) => {
    callback(event.detail?.darkMode ?? getStoredDarkMode());
  };

  window.addEventListener(THEME_EVENT, handler);
  return () => window.removeEventListener(THEME_EVENT, handler);
}
